// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__39Vds","name":"Header_name__XlC-V","birthday":"Header_birthday__2LqYz","skeleton":"Header_skeleton__3SXMk"};